import { props, createAction } from '@ngrx/store';
import { ContractError, User } from 'src/app/core/models/models';

export const SaveToken = createAction('[Auth] Saving token', props<{ token: string }>());

export const SaveUser = createAction('[Auth module] Save User', props<{ user: User }>());

export const LoadUserInfoSuccess = createAction(
  '[Auth] Load user info success',
  props<{ user: User }>()
);

export const InvalidToken = createAction('[Auth] InvalidToken');

export const Logout = createAction(
  '[Auth] Logout',
  props<{ token: string; isNoToken?: boolean }>()
);

export const DeleteStore = createAction('[Auth] Delete Store');

export const RefreshToken = createAction('[Auth] Refresh token', props<{ openSignin: boolean }>());

export const GetEndpoint = createAction('[Auth] Get Endpoint');

export const SaveEndpoint = createAction('[Auth] Save Endpoint', props<{ endpoint: string }>());

export const LoadAuthEndpointsFail = createAction(
  '[Auth] Load Endpoints info fail',
  props<{ error: ContractError }>()
);

export const openSignin = createAction('[Auth] OpenSignin', props<{ isOpen: boolean }>());

export const SaveLang = createAction('[Auth] Save Lang', props<{ lang: string }>());

export const CloseSession = createAction(
  '[Auth] close session',
  props<{ closeSession: boolean }>()
);
